import React from "react";
import {CardBody, CardText, CardTitle, Row} from "reactstrap";

const AlertHistoryCard = ({data}) => {
  const {timestamp = "", message = "", type = ""} = data;
  return (
    <>
      <Row>
        <div className="col-12 mt-3">
          <div style={{display: "flex", flex: "1 1 auto"}}>
            <CardBody>
              <CardTitle tag="h4">
                Timestamp <CardText>{timestamp}</CardText>{" "}
              </CardTitle>
              <CardTitle tag="h4">
                Message <CardText>{message}</CardText>{" "}
              </CardTitle>
              <CardTitle tag="h4">
                Type <CardText>{type}</CardText>{" "}
              </CardTitle>
            </CardBody>
          </div>
        </div>
      </Row>
    </>
  );
};

export default AlertHistoryCard;
